import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { academylist, feereportlist } from "../../../services/admin";
import moment from "moment";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react";
import {
  stuacademicyearlist,
  stuclasslist,
  studivisionlist,
  stufeetypelist,
} from "../../../services/master";

export default function FeePaymentReport() {
  const [allData, setAllData] = useState([]);
  const [activeTab, setActiveTab] = useState("all");

  const [aclist, setAcList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [alist, setAList] = useState([]);
  const [ayear, setAYear] = useState("");
  const [clist, setCList] = useState([]);
  const [stucls, setStuCls] = useState("");
  const [seclist, setSecList] = useState([]);
  const [stusec, setStuSec] = useState("");
  const [flist, setFlist] = useState([]);
  const [ftype, setFType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [stuSearch, setStuSearch] = useState("");
  // Whole vs Individual fee structure filter: "all" | "whole" | "individual".
  const [structFilter, setStructFilter] = useState("all");
  // Extra filters surfaced for monthly / transport(stage) fee types.
  const [monthFilter, setMonthFilter] = useState("");
  const [stageFilter, setStageFilter] = useState("");

  const gridRef = useRef(null);

  // Months / stages present in the loaded data (drive the conditional filters).
  const monthOptions = [
    ...new Set(allData.map((i) => i.fee_month_raw).filter(Boolean)),
  ].sort();
  const stageOptions = (() => {
    const map = {};
    allData.forEach((i) => {
      if (i.stage_id) {
        map[i.stage_id] =
          i.stage_name || (i.route_name ? i.route_name + " stage" : "Stage " + i.stage_id);
      }
    });
    return Object.entries(map).map(([value, label]) => ({ value, label }));
  })();

  // Scope everything (cards, tabs, grid) to the selected structure/month/stage.
  const scopedData = allData.filter((i) => {
    if (structFilter !== "all" && (i.structure_type || "Whole").toLowerCase() !== structFilter)
      return false;
    if (monthFilter && i.fee_month_raw !== monthFilter) return false;
    if (stageFilter && String(i.stage_id || "") !== String(stageFilter)) return false;
    return true;
  });

  const paidList = scopedData.filter((i) => i.status === "Paid");
  const unpaidList = scopedData.filter((i) => i.status === "Unpaid");
  const partialList = scopedData.filter((i) => i.status === "Partially Paid");

  const tabData =
    activeTab === "paid"
      ? paidList
      : activeTab === "pending"
      ? unpaidList
      : activeTab === "partial"
      ? partialList
      : scopedData;

  const displayData = stuSearch.trim()
    ? tabData.filter((i) =>
        (i.student_name || "").toLowerCase().includes(stuSearch.toLowerCase())
      )
    : tabData;

  const totalCollected = scopedData.reduce(
    (sum, i) => sum + parseFloat(i.paid_amount || 0),
    0
  );
  const totalPending = scopedData.reduce(
    (sum, i) => sum + parseFloat(i.pending_amount || 0),
    0
  );
  const totalDiscount = scopedData.reduce(
    (sum, i) => sum + parseFloat(i.disc_amt || 0),
    0
  );

  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true && res.data.details.length > 0) {
        const arr = res.data.details.map((d) => ({
          value: d.id,
          label: d.name + " - " + d.code,
        }));
        setAcList(arr);
      }
    });

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true && res.data.details.length > 0) {
          const match = res.data.details.find(
            (d) => d.id == localStorage.getItem("AAcademy")
          );
          if (match) {
            const item = { value: match.id, label: match.name + " - " + match.code };
            setAcaID(item);
            listyear(item);
          }
        }
      });
    }

    stuclasslist().then((res) => {
      if (res.status === true && res.data.length > 0) {
        setCList(res.data.map((d) => ({ value: d.id, label: d.class_name })));
      }
    });

    studivisionlist().then((res) => {
      if (res.status === true && res.data.length > 0) {
        setSecList(res.data.map((d) => ({ value: d.id, label: d.name })));
      }
    });
  }, []);

  function listyear(aid) {
    setAList([]);
    setAYear("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    stuacademicyearlist(temp).then((res) => {
      if (res.status === true && res.data.length > 0) {
        setAList(res.data.map((d) => ({ value: d.id, label: d.aca_year })));
      }
    });
    stufeetypelist(temp).then((res) => {
      if (res.status === true) setFlist(res.data);
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listyear(e);
      listall(e, ayear, stucls, stusec, ftype, fromDate, toDate);
    } else {
      setAcaID("");
      listyear("");
      listall("", ayear, stucls, stusec, ftype, fromDate, toDate);
    }
  }

  function listall(aid, ayr, scls, ssec, ftye, fdate, tdate) {
    setAllData([]);
    setActiveTab("all");
    setStuSearch("");
    setMonthFilter("");
    setStageFilter("");
    setAYear(ayr);
    setStuCls(scls);
    setStuSec(ssec);
    setFType(ftye);
    setFromDate(fdate);
    setToDate(tdate);
    setLoading(true);

    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("year_id", ayr);
    temp.append("class_id", scls);
    temp.append("section_id", ssec);
    temp.append("feetype", ftye);
    if (fdate) temp.append("from_date", fdate);
    if (tdate) temp.append("to_date", tdate);

    feereportlist(temp).then((res) => {
      setLoading(false);
      if (res.status === true) {
        const arr = res.data.map((item) => ({
          ...item,
          paid_date: item.paid_date ? moment(item.paid_date).format("DD-MM-YYYY") : "",
          due_date: item.due_date ? moment(item.due_date).format("DD-MM-YYYY") : "",
          fee_month_raw: item.fee_month || "",
          fee_month: item.fee_month ? moment(item.fee_month, "YYYY-MM").format("MMM YYYY") : "",
        }));
        setAllData(arr);
      }
    });
  }

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/user.png");
    ev.target.onerror = null;
  }

  const columnDefs = [
    {
      headerName: "Photo",
      field: "photo",
      width: 80,
      filter: false,
      floatingFilter: false,
      resizable: true,
      cellRenderer: (params) => (
        <div className="text-center">
          <img
            src={
              params.value
                ? params.data.path + params.value
                : require("../../../assets/images/user.png")
            }
            style={{ width: "40px", height: "40px", borderRadius: "50%" }}
            onError={errorphoto}
          />
        </div>
      ),
      valueGetter: (params) =>
        params.data.photo ? `${params.data.path}${params.data.photo}` : "",
    },
     {
      headerName: "Status",
      field: "status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) => {
        const color =
          params.value === "Paid"
            ? "success"
            : params.value === "Unpaid"
            ? "danger"
            : "warning";
        return <span className={`badge bg-${color}`}>{params.value}</span>;
      },
    },
    {
      headerName: "Name",
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Section",
      field: "section_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Fee Type",
      field: "fee_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Structure",
      field: "structure_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: (params) => {
        const color = params.value === "Individual" ? "info" : "secondary";
        return <span className={`badge bg-${color}`}>{params.value}</span>;
      },
    },
    {
      headerName: "Month",
      field: "fee_month",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Stage / Route",
      field: "stage_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      valueGetter: (p) =>
        p.data.stage_name
          ? p.data.route_name
            ? `${p.data.stage_name} (${p.data.route_name})`
            : p.data.stage_name
          : "",
    },
    {
      headerName: "Total",
      field: "total_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Paid",
      field: "paid_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Discount",
      field: "disc_amt",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Pending",
      field: "pending_amount",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "right" },
    },
    {
      headerName: "Paid Date",
      field: "paid_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Due Date",
      field: "due_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
   
  ];

  const downloadExcel = () => {
    const label =
      activeTab === "paid"
        ? "Paid Students"
        : activeTab === "pending"
        ? "Pending Students"
        : activeTab === "partial"
        ? "Partially Paid Students"
        : "All Fee Report";
    gridRef.current.api.exportDataAsCsv({
      fileName: `${label}.csv`,
      processCellCallback: (params) => {
        if (params.column.getColId() === "photo") {
          return params.value ? `=HYPERLINK("${params.value}", "View Photo")` : "";
        }
        return params.value;
      },
    });
  };

  const tabs = [
    { key: "all", label: "All", count: scopedData.length, color: "info" },
    { key: "paid", label: "Paid", count: paidList.length, color: "success" },
    { key: "pending", label: "Unpaid", count: unpaidList.length, color: "danger" },
    { key: "partial", label: "Partially Paid", count: partialList.length, color: "warning" },
  ];

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Fee Payment Report</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Fee Module</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Fee Payment Report
          </li>
        </ol>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          {/* Filters */}
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <Row className="row-sm mx-0">
                {localStorage.getItem("Role") === "1" && (
                  <Col xxl={4} lg={4} md={4}>
                    <div className="mb-3">
                      <label className="form-label">Select Academy</label>
                      <Select
                        className="default-select"
                        placeholder="Select Academy"
                        value={acaid}
                        options={aclist}
                        onChange={handleAcademy}
                        isSearchable
                        isClearable
                      />
                    </div>
                  </Col>
                )}
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">Academic Year</label>
                    <select
                      className="default-select form-control wide"
                      onChange={(e) =>
                        listall(acaid, e.target.value, stucls, stusec, ftype, fromDate, toDate)
                      }
                      value={ayear}
                    >
                      <option value="" disabled>Select Academic Year</option>
                      {alist.map((item) => (
                        <option value={item.value} key={item.value}>{item.label}</option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">Class</label>
                    <select
                      className="default-select form-control wide"
                      onChange={(e) =>
                        listall(acaid, ayear, e.target.value, stusec, ftype, fromDate, toDate)
                      }
                      value={stucls}
                    >
                      <option value="">All Classes</option>
                      {clist.map((item) => (
                        <option value={item.value} key={item.value}>{item.label}</option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">Section</label>
                    <select
                      className="default-select form-control wide"
                      onChange={(e) =>
                        listall(acaid, ayear, stucls, e.target.value, ftype, fromDate, toDate)
                      }
                      value={stusec}
                    >
                      <option value="">All Sections</option>
                      {seclist.map((item) => (
                        <option value={item.value} key={item.value}>{item.label}</option>
                      ))}
                    </select>
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">Fee Type</label>
                    <select
                      className="default-select form-control wide"
                      onChange={(e) =>
                        listall(acaid, ayear, stucls, stusec, e.target.value, fromDate, toDate)
                      }
                      value={ftype}
                    >
                      <option value="">All Fee Types</option>
                      {flist.map((item) => (
                        <option value={item.id} key={item.id}>{item.fee_type}</option>
                      ))}
                    </select>
                  </div>
                </Col>
                {monthOptions.length > 0 && (
                  <Col xxl={4} lg={4} md={4}>
                    <div className="mb-3">
                      <label className="form-label">Month</label>
                      <select
                        className="default-select form-control wide"
                        value={monthFilter}
                        onChange={(e) => {
                          setActiveTab("all");
                          setMonthFilter(e.target.value);
                        }}
                      >
                        <option value="">All Months</option>
                        {monthOptions.map((m) => (
                          <option value={m} key={m}>
                            {moment(m, "YYYY-MM").format("MMM YYYY")}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                )}
                {stageOptions.length > 0 && (
                  <Col xxl={4} lg={4} md={4}>
                    <div className="mb-3">
                      <label className="form-label">Stage / Route</label>
                      <select
                        className="default-select form-control wide"
                        value={stageFilter}
                        onChange={(e) => {
                          setActiveTab("all");
                          setStageFilter(e.target.value);
                        }}
                      >
                        <option value="">All Stages</option>
                        {stageOptions.map((s) => (
                          <option value={s.value} key={s.value}>
                            {s.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                )}
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">Structure</label>
                    <select
                      className="default-select form-control wide"
                      value={structFilter}
                      onChange={(e) => {
                        setActiveTab("all");
                        setStructFilter(e.target.value);
                      }}
                    >
                      <option value="all">All Structures</option>
                      <option value="whole">Whole</option>
                      <option value="individual">Individual</option>
                    </select>
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">From Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) =>
                        listall(acaid, ayear, stucls, stusec, ftype, e.target.value, toDate)
                      }
                    />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      min={fromDate || undefined}
                      onChange={(e) =>
                        listall(acaid, ayear, stucls, stusec, ftype, fromDate, e.target.value)
                      }
                    />
                  </div>
                </Col>
                <Col xxl={4} lg={4} md={4}>
                  <div className="mb-3">
                    <label className="form-label">Search Student</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by student name..."
                      value={stuSearch}
                      onChange={(e) => setStuSearch(e.target.value)}
                    />
                  </div>
                </Col>
                <Col xxl={12} lg={12} md={12}>
                  <div className="mb-3 text-end mt-4">
                    <a className="btn btn-success" onClick={downloadExcel}>
                      <i className="fa fa-download me-1"></i> Export
                    </a>
                  </div>
                </Col>
              </Row>
            </div>
          </div>

          {/* Summary Cards */}
          <Row className="mb-3">
            <Col xxl={3} lg={3} md={6} className="mb-3">
              <div className="card custom-card">
                <div className="card-body text-center">
                  <p className="tx-12 text-muted mb-1">Total Students</p>
                  <h3 className="tx-28 mb-1 text-primary">{scopedData.length}</h3>
                  <p className="tx-12 text-muted mb-0">All Records</p>
                </div>
              </div>
            </Col>
            <Col xxl={3} lg={3} md={6} className="mb-3">
              <div className="card custom-card">
                <div className="card-body text-center">
                  <p className="tx-12 text-muted mb-1">Total Collected</p>
                  <h3 className="tx-28 mb-1 text-success">
                    ₹{totalCollected.toFixed(2)}
                  </h3>
                  <p className="tx-12 text-muted mb-0">{paidList.length} Fully Paid</p>
                </div>
              </div>
            </Col>
            <Col xxl={3} lg={3} md={6} className="mb-3">
              <div className="card custom-card">
                <div className="card-body text-center">
                  <p className="tx-12 text-muted mb-1">Total Pending</p>
                  <h3 className="tx-28 mb-1 text-danger">
                    ₹{totalPending.toFixed(2)}
                  </h3>
                  <p className="tx-12 text-muted mb-0">{unpaidList.length} Unpaid</p>
                </div>
              </div>
            </Col>
            <Col xxl={3} lg={3} md={6} className="mb-3">
              <div className="card custom-card">
                <div className="card-body text-center">
                  <p className="tx-12 text-muted mb-1">Total Discount</p>
                  <h3 className="tx-28 mb-1 text-warning">
                    ₹{totalDiscount.toFixed(2)}
                  </h3>
                  <p className="tx-12 text-muted mb-0">{partialList.length} Partial</p>
                </div>
              </div>
            </Col>
          </Row>

          {/* Tabs + Grid */}
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              {loading && (
                <div className="text-center py-3">
                  <div className="spinner-border text-primary" role="status"></div>
                </div>
              )}
              {!loading && (
                <>
                  <div className="d-flex mb-3 flex-wrap" style={{ gap: "12px" }}>
                    {tabs.map((tab) => (
                      <button
                        key={tab.key}
                        className={`btn btn-sm ${
                          activeTab === tab.key ? `btn-${tab.color}` : ""
                        }`}
                        style={
                          activeTab !== tab.key
                            ? { backgroundColor: "#e2e5e8", border: "none", color: "#495057" }
                            : {}
                        }
                        onClick={() => setActiveTab(tab.key)}
                      >
                        {tab.label}{" "}
                        <span className={`badge ms-1 ${activeTab === tab.key ? "bg-white text-dark" : "bg-secondary text-white"}`}>
                          {tab.count}
                        </span>
                      </button>
                    ))}
                  </div>
                  <div className="ag-theme-alpine ag-style">
                    <AgGridReact
                      ref={gridRef}
                      columnDefs={columnDefs}
                      rowData={displayData}
                      pagination={true}
                      paginationPageSize={10}
                      sortingOrder={["asc", "desc"]}
                      suppressDragLeaveHidesColumns={true}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
